var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c('span',{staticClass:"background"})])
}
var staticRenderFns = []

export { render, staticRenderFns }